import useTabManager from '@/pages/function/hook/useTabManager';
import { FUNC_MAIN_TAB_BUTTON } from '@/pages/function/constants/index';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useRef } from 'react';
import { Swiper as SwiperType } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/navigation';

const MainTabButtonListBox = () => {
	const { funcClickTab } = useTabManager();
	const swiperRef = useRef<SwiperType | null>(null);

	useEffect(() => {
		const hash = window.location.hash.replace('#', '');
		const targetIndex = FUNC_MAIN_TAB_BUTTON.findIndex(tab => tab.hash === hash);
		if (targetIndex !== -1 && swiperRef.current) {
			swiperRef.current.slideTo(targetIndex);
		}
	}, []);

	const onTabClick = (index: number) => {
		window.location.hash = FUNC_MAIN_TAB_BUTTON[index].hash;
		swiperRef.current?.slideTo(index);
		funcClickTab(index, 'main');
	};

	return (
		<div className="sub-tab">
			<Swiper
				modules={[Navigation]}
				spaceBetween={16}
				slidesPerView="auto"
				navigation={{
					nextEl: '.swiper-nav .swiper-button-next',
					prevEl: '.swiper-nav .swiper-button-prev'
				}}
				onSwiper={(swiper: any) => {
					swiperRef.current = swiper;
				}}>
				{FUNC_MAIN_TAB_BUTTON.map((item, idx) => (
					<SwiperSlide key={item.key}>
						<button className="tab-btn" onClick={() => onTabClick(idx)}>
							{item.label}
						</button>
					</SwiperSlide>
				))}
			</Swiper>
			<div className="swiper-nav">
				<div className="swiper-button-prev"></div>
				<div className="swiper-button-next"></div>
			</div>
		</div>
	);
};

export default MainTabButtonListBox;
